import React, { useMemo } from 'react';
import GlobalLayout from 'components/common/general/layouts/GlobalLayout';
import { useHistory } from 'react-router-dom';
import ProductTemplateSidebar from 'components/common/rfq/ProductTemplateSidebar';
import { PRODUCT_TEMPLATE_CARD_DATA } from 'global/checklists-helpers/ProductTemplateChecklistHelper';
import RFQPlanAttributes from 'components/rfq/product-template/rfq-plan-attributes';
import RFQChecklistOptionHeader from 'components/common/headers/RFQChecklistOptionHeader';
import RFQPlanAttributesPageStore, { PageStoreContext } from 'store/pages/rfq/rfq-template/plan-attributes/pageStore';
import { observer } from 'mobx-react-lite';
import useRfqTemplate from 'global/hooks/useRfqTemplate';
import { createStyles } from '../../../../globalStyles';
import { createStyles as createCustomStyles } from './styles';

const RFQPlanAttributesPage = observer((): JSX.Element => {
  const classes = createStyles();
  const customClasses = createCustomStyles();

  const history = useHistory();

  const { templateId, pageType } = useRfqTemplate();
  if (!templateId) return <></>;

  const pageStore = useMemo(() => new RFQPlanAttributesPageStore(templateId), []);

  const returnBack = (): void => {
    history.push(`/product-template-checklist/${templateId}?type=${pageType}`);
  };

  return (
    <GlobalLayout
      leftSection={<ProductTemplateSidebar />}
      rightSection={
        <div className={classes.pageWrapper}>
          <RFQChecklistOptionHeader
            title={PRODUCT_TEMPLATE_CARD_DATA.PLAN_ATTRIBUTES.title}
            onRedirectBack={returnBack}
            className={customClasses.header}
          />
          <PageStoreContext.Provider value={pageStore}>
            <RFQPlanAttributes />
          </PageStoreContext.Provider>
        </div>
      }
    />
  );
});

export default RFQPlanAttributesPage;
